import React, {Component} from "react";
import {Button, message, Switch ,Input, Radio,Form,Icon,Select,Alert } from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import {hasAuth} from "../../../utils/NHCore";
import NHTable from '../../common/NHTable';
import {NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import NHFormItem from '../../common/NHFormItem';
import NHSelect from '../../common/NHSelect/index';
import NHInputRender from '../../common/NHInputPicker/render';
import css from './index.css';
import { Scrollbars } from 'react-custom-scrollbars'

const FormItem = Form.Item;
const { TextArea } = Input;
const RadioGroup = Radio.Group;
class IndexComponet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            djfsSelectData: [],  //对接方式下拉选择框数据
            initData:{},
            judgePkid:false,
            djfsid:'',//对接方式id获取对接参数
            dynamicData: [],
            zfd:''
        };
    }

    componentDidMount() {
        NHFetch(`api/zhxg-jfxt/onPay/getJccs`, 'GET')
        .then(res => {
            if (res) {
                this.setState({ initData:res.data })
                if(res.data.DJFSID){
                    let djfsid = res.data.DJFSID;
                    this.handleDynamicData(djfsid);
                }
                if(res.data.PKID){
                    this.setState({ judgePkid:true })
                }
                if(res.data.ZFD){
                    this.setState({ zfd:res.data.ZFD })
                }
            }
        })
        NHFetch(`api/zhxg-jfxt/onPay/getDjfsid`, 'GET')
        .then(res => {
            if (res) {
                this.setState({ djfsSelectData:res.data })
            }
        })
    }

    handleDynamicData = (djfsid) =>{
        NHFetch(`api/zhxg-jfxt/onPay/${djfsid}/getAllDockingParam`, "GET" )
        .then(res => {
            if (res) {
                this.setState({ dynamicData:res.data })
            }
        })
    }

    handleDjfsid = (e) =>{
        this.handleDynamicData(e);
    }

    handleZfd = (e) =>{
        this.setState({zfd:e.target.value})
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let formData = [];
                for (let key in values) {
                    let itemData = {};
                    itemData.djcszid = key;
                    let value = values[key];
                    if (typeof value === 'object') {
                        let v = value[value.length - 1];
                        if (v) {
                            if (v.hasOwnProperty('uuid') && v['uuid']) {
                                itemData.csz = v['uuid'];
                            } else {
                                itemData.csz = v;
                            }
                        }
                    } else {
                        itemData.csz = value;
                    }
                    formData.push(itemData);
                }
                NHFetch(`api/zhxg-jfxt/onPay/updateCsz`, 'POST',formData)
                .then(res => {
                    if (res && res.code === 200) {
                        if(this.state.judgePkid===true){
                            values.pkid='1';
                            if(!values.zfts){
                                values.zfts="";
                            }
                            NHFetch(`api/zhxg-jfxt/onPay/updateJccs`, 'POST',values)
                            .then(res => {
                                if (res && res.code === 200) {
                                    message.success("提交基础数据信息成功！");
                                }
                            })
                        }else{
                            values.pkid='1';
                            if(!values.zfts){
                                values.zfts="";
                            }
                            NHFetch(`api/zhxg-jfxt/onPay/insertJccs`, 'POST',values)
                            .then(res => {
                                if (res && res.code === 200) {
                                    message.success("提交基础数据信息成功！");
                                }
                            })
                        }
                    }
                })
            }
        });
    };

    

    render() {
        const {form} = this.props;
        const {djfsSelectData} = this.state;
        let jfOptions = [];
        if (djfsSelectData) {
            jfOptions = djfsSelectData.map((item, index) => <Select.Option key={index}
                                                                           value={item.VALUE}>{item.LABEL}</Select.Option>);
        }

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 12, offset: 6},
                md: {span: 10, offset: 7},
            }
        };
        let formItems = [];
        const dynamicData = this.state.dynamicData;
        if(dynamicData.length>0){
            let mc = dynamicData[0].DJFSMC;
            let tempItems = [];
            tempItems.push((
                <FormItem {...tailFormItemLayout} key={mc}>
                    <p style={{fontWeight: 'bold', fontSize: 16, borderBottom: '1px solid #efefef'}}>
                        <Icon type="setting"/>{mc}参数设置
                    </p>
                </FormItem>
            ));
            //渲染参数设置项
            for (let param of dynamicData) {
                let formItem = (
                    <NHInputRender key={param.DJCSZID} id={param.DJCSZID} label={param.ZDMC} value={param.CSZ}
                                    form={form}
                                    feature={param.BDKJCS}/>);
                tempItems.push(formItem);
            }
            formItems = formItems.concat(tempItems);
        }else {
            formItems.push((
                <FormItem {...tailFormItemLayout} key={"info"}>
                    <Alert message="暂无参数设置项，请到参数设置项里添加！" type="info" showIcon/>
                </FormItem>
            ));
        }

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH + 150}}>
                <Scrollbars autoHide style={{ width: '100%', height: '100%' }}>
                    <div>
                        <Form>
                            <NHFormItem label="对接方式" id={'djfsid'} form={form} initialValue={this.state.initData?this.state.initData.DJFSID:null} required={true}>
                                <Select placeholder='请选择...' style={{ width:'350px' }} onChange={this.handleDjfsid}>
                                    <Select.Option value="">请选择...</Select.Option>
                                    {jfOptions}
                                </Select>
                            </NHFormItem>
                            <NHFormItem label="支付端" id={'zfd'} form={form} initialValue={this.state.initData?this.state.initData.ZFD:"0"} required={true}>
                                <RadioGroup onChange={this.handleZfd}>
                                    <Radio value={"0"}>不支付</Radio>
                                    <Radio value={"1"}>PC端</Radio>
                                    <Radio value={"2"}>移动端</Radio>
                                    <Radio value={"12"}>PC端和移动端</Radio>
                                </RadioGroup>
                            </NHFormItem>
                            {
                                this.state.zfd=="1"||this.state.zfd=="12"?<NHFormItem label="PC支付路径" id={'pczflj'} form={form} initialValue={this.state.initData?this.state.initData.PCZFLJ:null} required={true}>
                                    <Input placeholder={'请输入PC支付路径...'} style={{ width:'350px' }}/>
                                </NHFormItem>:null
                            }
                            {
                                this.state.zfd=="2"||this.state.zfd=="12"?<NHFormItem label="移动支付路径" id={'ydzflj'} form={form} initialValue={this.state.initData?this.state.initData.YDZFLJ:null} required={true}>
                                    <Input placeholder={'请输入移动支付路径...'} style={{ width:'350px' }}/>
                                </NHFormItem>:null
                            }
                            <NHFormItem label="是否可以编辑缴费金额" id={'sfkybjjrfje'} form={form} initialValue={this.state.initData?this.state.initData.SFKYBJJRFJE:"0"} required={true}>
                                <RadioGroup>
                                    <Radio value={"0"}>不可以编辑</Radio>
                                    <Radio value={"1"}>可以编辑</Radio>
                                </RadioGroup>
                            </NHFormItem>
                            <NHFormItem label="支付提示" id={'zfts'} form={form} initialValue={this.state.initData?this.state.initData.ZFTS:null}>
                                <TextArea placeholder={'请输入支付提示...'} style={{ width:'350px' }} rows={3}/>
                            </NHFormItem>
                            {formItems}
                            <div style={{textAlign:"center"}}>
                                {hasAuth("zhxg_yxxt_zxjfgl_jfcssz:update") &&
                                <Button type="primary" onClick={this.handleSubmit} >提交</Button>}
                            </div>
                        </Form>
                    </div>
                </Scrollbars>
            </div>
        );
    }
}

const IndexForm = Form.create()(IndexComponet);
export default IndexForm;


// WEBPACK FOOTER //
// ./components/zxjfgl/jfcssz/index.js